import {CamResponse} from '../../data-service'
import {Grid, Typography, useTheme} from '@material-ui/core'
import {useParams} from 'react-router-dom'
import Player from '../../components/player/Player'
import React, {useEffect} from 'react'
import {get} from 'lodash'

interface AgrrementProps {
    data: CamResponse;
    useThemeHook?: any;
}

export default function Agreement({data, useThemeHook = useTheme}: AgrrementProps) {
	const theme = useThemeHook()
	const spacing: number = theme.spacing()

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

	return <>
		<Grid
			style={{backgroundColor: 'transparent', minHeight: '35vh'}}
			container
			spacing={2}
			direction="row"
			justifyContent="flex-start"
			alignItems="stretch"
		>
			<Grid item xs={12}>
				<Typography variant="h5" component="h1"
					style={{paddingTop: `${spacing * 2}px`, paddingBottom: `${spacing * 2}px`}}>
					{get(data, 'content.agreement[0].title', '')}
				</Typography>
			</Grid>

			<Grid item xs={12}>
				<div dangerouslySetInnerHTML={{__html: get(data, 'content.agreement[0].content', '')}}/>
			</Grid>
		</Grid>
	</>
}
